export default "__VITE_ASSET__B4Kl268g__"